<template>
  <component :is="tag" v-on="$listeners">
    <div class="operator-group">
      <b-avatar
        class="merchant-profile"
        size="42"
        :variant="isActive ? 'light-light' : 'light-primary'"
        :src="getAvatarUrl(room)"
        :text="avatarText(room)"
      >
        <feather-icon
          v-if="!getAvatarUrl(room) && !avatarText(room)"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
      <b-avatar
        size="42"
        :badge="true"
        class="badge-minimal customer-profile"
        :badge-variant="room.isOnline ? 'success' : 'secondary'"
        :variant="isActive ? 'light-light' : 'light-primary'"
      >
        <feather-icon icon="UserIcon" size="22" />
      </b-avatar>
    </div>
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0 text-truncate">
        {{ room.nameMember }}
      </h5>
      <p v-if="room.lastMessage" class="card-text text-truncate">
        <span v-if="room.lastMessage.type == 'text'">
          <span v-if="room.lastMessage.status == 'reject'">
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}: {{ $t("action.canNotSendBankOrPhoneInfo") }}
          </span>
          <span v-else="room.lastMessage.status == 'sent'">
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}: {{ room.lastMessage.message }}
          </span>
          <span v-else>
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}: {{ room.lastMessage.message }}
          </span>
        </span>
        <span v-else-if="room.lastMessage.type == 'activity'">
          <span v-if="room.lastMessage.message == 'activity.group.create'">
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.createTheGroup") }}
          </span>
          <span v-if="room.lastMessage.message == 'activity.group.left'">
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }},
            {{ $t("chat.leaveThisRoom") }}
          </span>
          <span v-else-if="room.lastMessage.message == 'activity.group.join'">
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }},
            {{ $t("chat.joinThisRoom") }}
          </span>
          <span
            v-else-if="room.lastMessage.message == 'activity.operator.invite'"
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.inviteOperator") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'activity.operator.unavailable'
            "
          >
            {{ $t("general.system") }}:
            {{ $t("action.operatorUnavailable") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_placed_auto' ||
              room.lastMessage.message == 'Order_placed_auto'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderPlacedAuto") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_placed_manual' ||
              room.lastMessage.message == 'Order_placed_manual'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderPlacedManual") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_accept' ||
              room.lastMessage.message == 'Order_accept'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderAccept") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_cancelled' ||
              room.lastMessage.message == 'Order_cancelled'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderCancelled") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_timeout' ||
              room.lastMessage.message == 'Order_timeout'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderTimeout") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_paid' ||
              room.lastMessage.message == 'Order_paid'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderPaid") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'receipt_rejected' ||
              room.lastMessage.message == 'Receipt_rejected'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.receiptRejected") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'receipt_confirmed' ||
              room.lastMessage.message == 'Receipt_confirmed'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.receiptConfirmed") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_suspended' ||
              room.lastMessage.message == 'Order_suspended'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderSuspended") }}
          </span>
          <span
            v-else-if="
              room.lastMessage.message == 'order_completed' ||
              room.lastMessage.message == 'Order_completed'
            "
          >
            {{
              room.lastMessage.sender.merchantUserId == userData.id
                ? $t("chat.you")
                : room.lastMessage.sender.name
            }}:
            {{ $t("action.orderCompleted") }}
          </span>

          <span v-else>
            {{ room.lastMessage.message }}
          </span>
        </span>
        <span v-else-if="isMediaOrFile(room)">
          {{
            $t("chat.sendAnAttachment", {
              user:
                room.lastMessage.sender.merchantUserId == userData.id
                  ? $t("chat.you")
                  : room.lastMessage.sender.name,
            })
          }}
        </span>
        <span v-else>
          {{ room.lastMessage.type }}
        </span>
      </p>
    </div>
    <div class="chat-meta text-nowrap">
      <small v-if="room.lastMessage" class="d-block mb-25 chat-time">
        {{ room.lastMessage.createdAt | formatShortDate }}
      </small>
      <b-badge
        v-if="room.unreadCount >= 1"
        pill
        variant="primary"
        class="float-right"
      >
        {{ room.unreadCount }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from "bootstrap-vue";
import messageType from "@/data/messageType";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    room: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageType,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  methods: {
    getAvatarUrl(room) {
      return room?.lastMessage?.sender?.avatar || null;
    },
    isMediaOrFile(room) {
      return (
        room.lastMessage.type == "media" || room.lastMessage.type == "file"
      );
    },
    avatarText(room) {
      const name = room?.lastMessage?.sender?.name;
      if (!name) return "";
      return name.charAt(0).toUpperCase();
    },
  },
};
</script>

<style></style>
